<div>
  Are you sure you want to delete "{{image.title}}"?
</div>
<a class="btn btn-primary m-1" [routerLink]="['/images', 'image', image.id]">Cancel</a>
<a class="btn btn-outline-warning m-1" (click)="delete()">Delete</a>
